import { Form, Select, Row, Col, Input, Checkbox, InputNumber } from "antd";

const { Option } = Select;

export default function StepRoleSelection({
  termsAccepted,
  setTermsAccepted,
  setIsModalVisible,
  categories
}) {
  const handleCheckboxClick = (e) => {
    e.preventDefault();

    if (termsAccepted) {
      setTermsAccepted(false);
    } else {
      setIsModalVisible(true);
    }
  };

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Form.Item
          name="role"
          label="Tipo de usuario"
          rules={[{ required: true, message: "Selecciona un rol" }]}
        >
          <Select placeholder="Selecciona un tipo">
            <Option value={4}>Comprador</Option>
            <Option value={6}>Proveedor</Option>
          </Select>
        </Form.Item>
      </Col>

      <Form.Item noStyle shouldUpdate={(prev, curr) => prev.role !== curr.role}>
        {({ getFieldValue }) => {
          const role = getFieldValue("role");

          if (role === 6) {
            return (
              <>
                <Col span={24}>
                  <Form.Item name="url" label="Página web">
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="categories"
                    label="Categoría"
                    rules={[{ required: true, message: "Selecciona una categoría" }]}
                  >
                    <Select placeholder="Selecciona categoría">
                      {categories.map((c) => (
                        <Option key={c.key} value={c.key}>
                          {c.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="iva"
                    label="% IVA"
                    rules={[{ required: true, message: "Selecciona el IVA" }]}
                  >
                    <Select>
                      <Option value={0.16}>16%</Option>
                      <Option value={0.08}>8%</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </>
            );
          }

          if (role === 4) {
            return (
              <Col span={24}>
                <Form.Item
                  name="pay_days"
                  label="Días de pago"
                  rules={[{ required: true, message: "Selecciona la cantidad" }]}
                >
                  <InputNumber min={1} style={{ width: "100%" }} />
                </Form.Item>
              </Col>
            );
          }

          return null;
        }}
      </Form.Item>

      <Col span={24}>
        <Form.Item
          name="terms"
          valuePropName="checked"
          rules={[
            {
              validator: (_, value) =>
                value ? Promise.resolve() : Promise.reject("Debes aceptar los términos")
            }
          ]}
        >
          <Checkbox checked={termsAccepted} onClick={handleCheckboxClick}>
            Acepto los términos y condiciones
          </Checkbox>
        </Form.Item>
      </Col>
    </Row>
  );
}
